import crypto from 'crypto'

export default {
	// 加密
	Encrypt(data, key, iv) {
		iv = iv || "";
		var clearEncoding = 'utf8';
		var cipherEncoding = 'base64';
		var cipherChunks = [];
		var cipher = crypto.createCipheriv('aes-128-cbc', key, iv);
		cipher.setAutoPadding(true);
		cipherChunks.push(cipher.update(data, clearEncoding, cipherEncoding));
		cipherChunks.push(cipher.final(cipherEncoding));
		return cipherChunks.join('');
	},
	// 解密
	Decrypt(data, key, iv) {
		if (!data) {
			return "";
		}
		iv = iv || "";
		var clearEncoding = 'utf8';
		var cipherEncoding = 'base64';
		var cipherChunks = [];
		var decipher = crypto.createDecipheriv('aes-128-cbc', key, iv);
		decipher.setAutoPadding(true);
		cipherChunks.push(decipher.update(data, cipherEncoding, clearEncoding));
		cipherChunks.push(decipher.final(clearEncoding));
		return cipherChunks.join('');
	}
}
